import { FC } from 'react';
import { useLocation } from 'react-router-dom';

import type { MenuProps } from 'antd';
import { Menu } from 'antd';

import { MENU_ITEMS_ADV, MENU_ITEMS_PUB } from 'features/Navigation';
import { EMainRoutes } from 'shared/typings';
import { useSidebarSlice } from 'widgets/Sidebar';

interface INavigationProps extends MenuProps {
	isPublisher?: boolean;
}

export const Navigation: FC<INavigationProps> = ({ className, isPublisher, ...props }) => {
	const { pathname } = useLocation();
	const { toggleOpened } = useSidebarSlice();
	const selectedKey = pathname
		.split(isPublisher ? `/${EMainRoutes.PUBLISHER}/` : `/${EMainRoutes.ADVERTISER}/`)[1]
		.split('/')[0] || EMainRoutes.DASHBOARD;
	return (
		<Menu
			{...props}
			className={className}
			mode="inline"
			items={isPublisher ? MENU_ITEMS_PUB : MENU_ITEMS_ADV}
			onClick={() => toggleOpened(false)}
			selectedKeys={[selectedKey]}
			selectable={false}
		/>
	);
};
